import React from 'react';

import { SvgPathProps } from './Icon';

const ImgFile: React.FC<SvgPathProps> = ({ size, isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path
      fillRule={'evenodd'}
      d="M25.411 17.752a.906.906 0 110 1.813.906.906 0 010-1.813zm0 2.813a1.909 1.909 0 001.906-1.907 1.908 1.908 0 00-1.906-1.906 1.908 1.908 0 00-1.906 1.906c0 1.051.855 1.907 1.906 1.907zm.122 4.296l2.162-2.218 3.316 4.117h-3.876l-1.602-1.899zm-8.544 1.9l4.418-5.239 4.42 5.238h-8.838zm10.776-5.624l-2.88 2.956-3.478-4.122-6.57 7.79H33.1l-5.335-6.624zM12 39.1h24V8.9H12v30.2zm-1.3 1.3h26.6V7.6H10.7v32.8z"
    />
  );

  const normalHover = (
    <path
      fillRule={'evenodd'}
      d="M25.411 15.752a.906.906 0 110 1.813.906.906 0 010-1.813zm0 2.813a1.909 1.909 0 001.906-1.907 1.908 1.908 0 00-1.906-1.906 1.908 1.908 0 00-1.906 1.906c0 1.051.855 1.907 1.906 1.907zm.122 6.297l2.162-2.219 3.316 4.117h-3.876l-1.602-1.898zM16.99 26.76l4.418-5.238 4.42 5.238h-8.838zm10.776-5.623l-2.88 2.956-3.478-4.122-6.57 7.79H33.1l-5.335-6.624zM12 39.1h24V8.9H12v30.2zm-1.3 1.3h26.6V7.6H10.7v32.8z"
    />
  );

  return isHovered ? normalHover : normal;
};

export default ImgFile;
